import React, { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import { PMDialog } from "../../../utils/PMDialog";
import { contractLinesApi } from "../../../../api/contract_lines";
import { axiosWithToast } from "../../../Utils";

export const ContractLineGroupDialog = ({
  open,
  onClose,
  onSuccess,
  project,
  group,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });

  useEffect(() => {
    if (open) {
      if (group) {
        setFormData({
          title: group.title || "",
          description: group.description || "",
        });
      } else {
        setFormData({
          title: "",
          description: "",
        });
      }
    }
  }, [open, group]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!project?.id) return;

    setLoading(true);

    // For groups, we'll use contract_lines with group_row: true
    // This is a simplified approach - in a real implementation,
    // you might want a separate endpoint for groups
    const payload = {
      title: formData.title,
      description: formData.description,
      group_row: true,
    };

    try {
      if (group) {
        // Update group - Note: This assumes groups are stored as contract_lines with group_row: true
        // You may need to adjust this based on your API structure
        await axiosWithToast(
          contractLinesApi.updateContractLine(project.id, group.id, payload),
          () => {
            onSuccess();
          },
          () => {},
          () => {},
          "Oppdaterer gruppe..."
        );
      } else {
        // Create group
        await axiosWithToast(
          contractLinesApi.createContractLine(project.id, payload),
          () => {
            onSuccess();
          },
          () => {},
          () => {},
          "Oppretter gruppe..."
        );
      }
    } catch (error) {
      console.error("Error saving group:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PMDialog
      open={open}
      onClose={onClose}
      title={group ? "Rediger gruppe" : "Ny gruppe"}
      size="lg"
      closeOnOutsideClick={false}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <TextField
          label="Gruppetittel"
          value={formData.title}
          onChange={(e) => setFormData({ ...formData, title: e.target.value })}
          fullWidth
          variant="standard"
          required
        />

        <TextField
          label="Kommentar"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          fullWidth
          multiline
          rows={3}
          variant="standard"
        />

        <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
          <Button onClick={onClose} disabled={loading}>
            Avbryt
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {loading ? "Lagrer..." : group ? "Oppdater" : "Opprett"}
          </Button>
        </div>
      </form>
    </PMDialog>
  );
};

